import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import PageSchema from './components/PageSchema';
import PageCanonical from './components/PageCanonical';
const HomePage = lazy(() => import('./pages/HomePage'));
const Courses = lazy(() => import('./pages/Courses'));
const Blog = lazy(() => import('./pages/Blog'));
const Contact = lazy(() => import('./pages/Contact'));
const Post = lazy(() => import("./pages/Post"));
const Coursessingle = lazy(() => import("./pages/Coursessingle"));
const Thankyou = lazy(() => import("./pages/Thankyou"));
const Aboutus = lazy(() => import("./pages/Aboutus"));
const Product = lazy(() => import("./pages/Product"));
const Productinternal = lazy(() => import("./pages/Productinternal"));
const DesignStudio = lazy(() => import("./pages/DesignStudio"));
const Project = lazy(() => import("./pages/Project"));
const Harmonyinternal = lazy(() => import("./pages/Harmonyinternal"));
const SuccessPage = lazy(() => import("./pages/SuccessPage"));
const Oneonone = lazy(() => import("./pages/Oneonone"));
const NotFound = lazy(() => import("./pages/NotFound"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));



const App = () => {
  return (
    <div> 
      <Header />
      <PageSchema />
      <PageCanonical />
      <Suspense fallback={null}>
        <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/product" element={<Product />} />
        <Route
          path="/uniform-manufacturer/corporate-admin"
          element={<Navigate to="/uniform-manufacturer/pilot-uniforms-aviation" replace />}
        />
        <Route path="/uniform-manufacturer/:slug" element={<Productinternal />} />
        <Route path="/design-studio" element={<DesignStudio />} />
        <Route path="/project" element={<Project />} />
        <Route path="/ambience-and-harmony" element={<Harmonyinternal />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog/:slug" element={<Post />} />
        <Route path="/courses/:id" element={<Coursessingle />} /> 
        <Route path="/thank-you" element={<Thankyou />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/one-on-one-transformation" element={<Oneonone />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      </Suspense>
      <Footer />
    </div>
  );
};



export default App;
